import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

interface IOrgMetricsCardProps {
    orgId: string;
}

export default function OrgSettingsCard({ orgId }: IOrgMetricsCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardStack
            name="settings"
            title={t('common:settings.title')}
            description={t('common:organization.settings.description')}>
            <OrgLinks organizationId={orgId} variant={'orgSettings'} />
        </CardStack>
    );
}
